import {
    GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL,
    GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS,
    GET_BURN_SUPERVISOR_FAIL,
    GET_BURN_SUPERVISOR_SUCCESS,
    GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL,
    GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS,
    GET_ENTITY_DETAILS_FAIL,
    GET_ENTITY_DETAILS_SUCCESS,
    GET_FEEDSTOCK_SOURCE_FAIL,
    GET_FEEDSTOCK_SOURCE_SUCCESS,
    GET_PROJECT_DESCRIPTION_FAIL,
    GET_PROJECT_DESCRIPTION_SUCCESS,
    GET_PROJECT_STAKEHOLDERS_FAIL,
    GET_PROJECT_STAKEHOLDERS_SUCCESS,
    POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL,
    POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS,
    POST_BURN_SUPERVISOR_FAIL,
    POST_BURN_SUPERVISOR_SUCCESS,
    POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL,
    POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS,
    POST_ENTITY_DETAILS_FAIL,
    POST_ENTITY_DETAILS_SUCCESS,
    POST_FEEDSTOCK_SOURCE_FAIL,
    POST_FEEDSTOCK_SOURCE_SUCCESS,
    POST_PROJECT_DESCRIPTION_FAIL,
    POST_PROJECT_DESCRIPTION_SUCCESS,
    POST_PROJECT_STAKEHOLDERS_FAIL,
    POST_PROJECT_STAKEHOLDERS_SUCCESS,
    START_LOADING
} from '../../../actions/rof-burns/types/01-general-info';

const initialState = {
    loading: true,

    projectDescription: null,
    businessAsUsualForFeedstock: null,
    biocharAndWaterSupplyEquipment: null,
    feedstockSource: null,
    burnSupervisor: null,
    projectStakeholders: [],
    entityDetails: null,
};

export default function generalInfoReducer(state = initialState, action) {
    // console.log(state, action)
    // call description please
    const { type, payload } = action;

    switch (type) {
        case START_LOADING:
            return {
                ...state,
                loading: true
            }
        case GET_PROJECT_DESCRIPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                projectDescription: payload,
            };
        case GET_PROJECT_DESCRIPTION_FAIL:
            return {
                ...state,
                loading: false,
                projectDescription: payload,
            };
        case POST_PROJECT_DESCRIPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                projectDescription: payload,
            };
        case POST_PROJECT_DESCRIPTION_FAIL:
            return {
                ...state,
                loading: false,
                projectDescription: payload,
            };
        case GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                businessAsUsualForFeedstock: payload,
            };
        case GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL:
            return {
                ...state,
                loading: false,
                businessAsUsualForFeedstock: payload,
            };
        case POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                businessAsUsualForFeedstock: payload,
            };
        case POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL:
            return {
                ...state,
                loading: false,
                businessAsUsualForFeedstock: payload,
            };
        case GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharAndWaterSupplyEquipment: payload,
            };
        case GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false,
                biocharAndWaterSupplyEquipment: payload,
            };
        case POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharAndWaterSupplyEquipment: payload,
            };
        case POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false,
                biocharAndWaterSupplyEquipment: payload,
            };
        case GET_FEEDSTOCK_SOURCE_SUCCESS:
            return {
                ...state,
                loading: false,
                feedstockSource: payload,
            };
        case GET_FEEDSTOCK_SOURCE_FAIL:
            return {
                ...state,
                loading: false,
                feedstockSource: payload,
            };
        case POST_FEEDSTOCK_SOURCE_SUCCESS:
            return {
                ...state,
                loading: false,
                feedstockSource: payload,
            };
        case POST_FEEDSTOCK_SOURCE_FAIL:
            return {
                ...state,
                loading: false,
                feedstockSource: payload,
            };
        case GET_BURN_SUPERVISOR_SUCCESS:
            return {
                ...state,
                loading: false,
                burnSupervisor: payload,
            };
        case GET_BURN_SUPERVISOR_FAIL:
            return {
                ...state,
                loading: false,
                burnSupervisor: payload,
            };
        case POST_BURN_SUPERVISOR_SUCCESS:
            return {
                ...state,
                loading: false,
                burnSupervisor: payload,
            };
        case POST_BURN_SUPERVISOR_FAIL:
            return {
                ...state,
                loading: false,
                burnSupervisor: payload,
            };
        case GET_PROJECT_STAKEHOLDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectStakeholders: payload,
            };
        case GET_PROJECT_STAKEHOLDERS_FAIL:
            return {
                ...state,
                loading: false,
                projectStakeholders: payload,
            };
        case POST_PROJECT_STAKEHOLDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectStakeholders: payload,
            };
        case POST_PROJECT_STAKEHOLDERS_FAIL:
            return {
                ...state,
                loading: false,
                projectStakeholders: payload,
            };
        case GET_ENTITY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                entityDetails: payload,
            };
        case GET_ENTITY_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                entityDetails: payload,
            };
        case POST_ENTITY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                entityDetails: payload,
            };
        case POST_ENTITY_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                entityDetails: payload,
            };
        default:
            return state;
    }
}
